import script from "./SingleProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleProductTable.vue?vue&type=script&setup=true&lang=js"

import "./SingleProductTable.vue?vue&type=style&index=0&id=4d4c85de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4c85de"]])

export default __exports__